export default "__VITE_ASSET__4be57668__"